module.exports = __webpack_public_path__ + "static/media/main idea.1596ad6e.mp3";